import { Injectable } from '@angular/core';
import { FisheryNotice } from 'src/app/data-models/fishery-notice.model';
import { UserStorageService } from './user-storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FisheryNoticesService {

  private static notice_pouch: PouchDB.Database; // fishery notice pouch (read only)
  //Remote notice DB in Cloudant, the credentials are an API key specific to the notice DB that can be used read and replicate from but not write/alter the DB or documents within
  private static notice_couch: string = environment.fisheryNoticeEndpoint; 

  // global variable for accessing the complete list of fishery notices
  public static fisheryNotices: FisheryNotice[] = [];

  constructor() {

  }


  /*  ---------- Initialization Methods  ---------- */


  // open or create a pouch db for the user's fishery notices
  private static initializeNoticeDB(email: string): void {

    // a new fishery notice pouch db is created for each user (assuming userEmail is unique)
    this.notice_pouch = UserStorageService.getPouchDB('notices-' + email);

  }


  /*  ---------- Data Retrieval Methods  ---------- */

  /*
    To get rid of archived notices without affecting the remote we destroy the local notice database 
    to free space, then replicate. The design document on the Couch side ensures only non-archived notices are synced down.
  */
  public static async checkForNotices(email: string): Promise<any> {
      let filterDate = new Date();
    filterDate.setMonth(filterDate.getMonth() - 2);

      return new Promise<boolean>((res) => {
          this.initializeNoticeDB(email); // open pouch db
          this.notice_pouch.replicate.from(environment.fisheryNoticeEndpoint, {
              filter: 'fishery_notices/archivefilter',
              query_params: {"curr_date_iso": filterDate.toISOString()}
          }).on('complete', () => {
              console.log('Pulled fishery notices from couch');
              res(true);
          }).on('error', (err: any) => {
              console.log('Could not retrieve new notices: ' + err);
              res(false);
          });
      });

  }

  public static getAllNoticeDocs(email: string): Promise<boolean> {

    return new Promise<boolean>((res) => {
      this.initializeNoticeDB(email); // open pouch db
      this.notice_pouch.allDocs({include_docs: true}).then((docs: any) => {
        this.setNoticeData(docs);
        res(true);
     });
    });

  }


  /*  ---------- Set Global Variables  ---------- */


  public static setNoticeData(docs: any): void {

    this.fisheryNotices.length = 0; // clear any old data
    let filterDate = new Date();
    filterDate.setMonth(filterDate.getMonth() - 2);

    this.fisheryNotices = docs.rows.filter((doc: any) => new Date(doc.doc.receivedTime).toISOString() >= filterDate.toISOString())
      .map((doc: any) => FisheryNotice.transformAnonymous(doc.doc));

    let purgeNotices = docs.rows.filter((doc: any) => new Date(doc.doc.receivedTime).toISOString() < filterDate.toISOString());
    for (var doc of purgeNotices) {
      doc.doc.archived = true;
      doc.doc._deleted = true;
    }
    this.notice_pouch.bulkDocs(purgeNotices.map((n: any) => n.doc));
  }


  /*  ---------- Clear/Close Data  ---------- */


  
  // close the user's common pouch db (invoked on logout)
  public static closeNoticeDb(isAdmin: boolean): Promise<boolean> {

    this.fisheryNotices.length = 0; // clear global variable

    return new Promise<boolean>((res) => {
      if (isAdmin) {
        console.log('Destroying admin notices')
        if(this.notice_pouch) this.notice_pouch.destroy();
        res(true);
      } 
      else if (!this.notice_pouch) res(true);
      else {
        this.notice_pouch.close().then(() => {
          console.log('Closed fishery notice db');
          res(true);
        }).catch((err: { name: string }) => {
          console.log('Could not close fishery notice db: ' + err);
          res(false);
        });
      }
    });

  }

}



